import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UserContext} from '@gatewee/types/user';
import {GateweeCollapsibleDirective} from '../gatewee-collapsible/gatewee-collapsible.directive';
import {GateweeExpandChevronComponent} from '../gatewee-expand-chevron/gatewee-expand-chevron.component';
import {GateweeIconComponent} from '../gatewee-icon/gatewee-icon.component';

@Component({
  selector: 'gatewee-user-context',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    GateweeIconComponent,
    GateweeExpandChevronComponent,
    GateweeCollapsibleDirective,
  ],
  templateUrl: './gatewee-user-context.component.html',
  styleUrls: [
    './gatewee-user-context.component.css',
    '../styles/gatewee-collapsible-details.css',
  ],
})
export class GateweeUserContextComponent {
  @Input() userContext: UserContext | null | undefined;

  get ctx(): UserContext | null | undefined {
    return this.userContext;
  }

  get hasContent(): boolean {
    const u = this.userContext;
    if (!u) {
      return false;
    }
    return !!(
      u.date ||
      u.origin ||
      u.ipAddress ||
      u.userAgent ||
      u.referer ||
      u.locale ||
      u.deviceId ||
      u.fingerprint ||
      u.sessionId
    );
  }

  get summaryHint(): string {
    const u = this.userContext;
    const o = u?.origin?.toString().trim();
    if (o) {
      return o.length > 32 ? `${o.slice(0, 32)}…` : o;
    }
    const ip = u?.ipAddress?.trim();
    if (ip) {
      return ip;
    }
    return '';
  }
}
